import "./IntroParceiros.css";
import { useNavigate } from "react-router-dom";
import {
  useMemo,
  useRef,
  useState,
  useEffect,
} from "react";
import { verificaAdmin } from "../../../../components/utils/verificaAdmin";
import AdminParceiros from "./AdminParceiros/AdminParceiros";

function IntroParceiros({
  marcas,
  setMarcas,
  loading,
  localizacao,
}) {
  const navigate = useNavigate();
  const [podeEsquerda, setPodeEsquerda] = useState(false);
  const [podeDireita, setPodeDireita] = useState(false);

  const containerRef = useRef(null);
  // console.log("marcas", marcas)
  const parceirosIntro = useMemo(() => {
    if (!Array.isArray(marcas)) return [];



    return marcas.filter(
      m => m.localizacao === localizacao
    );
  }, [marcas, localizacao]);


  const [abrirAdminParceiro, setAbrirAdminParceiro] = useState(false);

  const isAdmin = verificaAdmin();

  const SCROLL_STEP = 300;

  const scrollLeft = () => {
    containerRef.current?.scrollBy({
      left: -SCROLL_STEP,
      behavior: "smooth",
    });
  };

  const scrollRight = () => {
    containerRef.current?.scrollBy({
      left: SCROLL_STEP,
      behavior: "smooth",
    });
  };

  useEffect(() => {
    atualizarBotoes();

    const el = containerRef.current;

    if (!el) return;

    el.addEventListener("scroll", atualizarBotoes);
    window.addEventListener("resize", atualizarBotoes);

    return () => {
      el.removeEventListener(
        "scroll",
        atualizarBotoes
      );

      window.removeEventListener(
        "resize",
        atualizarBotoes
      );
    };
  }, [parceirosIntro]);


  const atualizarBotoes = () => {
    const el = containerRef.current;

    if (!el) return;

    setPodeEsquerda(el.scrollLeft > 0);

    setPodeDireita(
      el.scrollLeft + el.clientWidth < el.scrollWidth - 2
    );
  };



  // 🚫 Não renderiza nada
  if (loading || parceirosIntro.length === 0) {
    return null;
  }






  return (
    <section className="intro-part5-wrapper">
      {podeEsquerda && (
        <button
          className="scroll-btn-parceiros left"
          onClick={scrollLeft}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="15 18 9 12 15 6" />
          </svg>
        </button>
      )}

      <div className="intro-part5-container">
        <div
          className="intro-part5-partners"
          ref={containerRef}
        >
          {parceirosIntro.map(parceiro => (
            <div
              className="partner-card"
              key={parceiro.id}
              onClick={() =>
                navigate(`/busca/${parceiro.nome}`)
              }
            >
              <img
                src={parceiro.imagem}
                alt={parceiro.nome}
              />
            </div>
          ))}


        </div>
      </div>

      {podeDireita && (
        <button
          className="scroll-btn-parceiros right"
          onClick={scrollRight}
        >
          <svg
            width="20"
            height="20"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="3"
            strokeLinecap="round"
            strokeLinejoin="round"
          >
            <polyline points="9 18 15 12 9 6" />
          </svg>
        </button>
      )}

      {isAdmin && (
        <button
          className="btn-editar-banner"
          onClick={() => setAbrirAdminParceiro(true)}
        >
          Editar
        </button>
      )}

      {abrirAdminParceiro && (
        <AdminParceiros
          marcas={marcas}
          setMarcas={setMarcas}
          localizacao={localizacao}
          onClose={() => setAbrirAdminParceiro(false)}
        />
      )}
    </section>
  );
}

export default IntroParceiros;
